/* eslint-disable-next-line import/no-unassigned-import, unicorn/no-unnecessary-polyfills -- polyfill by design */
import 'core-js/actual';
import { createRoot } from 'react-dom/client';
import ReactModal from 'react-modal';

import App from './App';

const app = document.querySelector('#app');

if (app) {
  const rootContainer = document.createElement('div');
  document.body.append(rootContainer);
  ReactModal.setAppElement(rootContainer);
  createRoot(rootContainer).render(<App />);
}
